import { isProductInStock } from '@mango-engineering/maknet-client-sdk/lib/shop/product/util/statusUtils';
import {
  RecommendationPayload,
  RecommendationResponse,
} from '../../types/common';
import { Product } from '../../types/product.types';
import {
  getProductAvailability,
} from '../../utils/helper';
import { getProductIdWithoutPrefix } from '../../utils/product.util';
import RecommendationErrorHandler from '../Error/RecommendationErrorHandler';
import ProductService from '../product/product.service';
import RecommendationServices from '../recommendation/recommendations.service';

export async function curatedRecommendations(
  payload: RecommendationPayload,
  assignRecommendationData?: (rProducts: RecommendationResponse) => void,
  mmid?: string,
): Promise<RecommendationResponse> {
  const data = await RecommendationServices.getSearchProducts(payload?.accessToken ?? '', payload.searchRequest);

  const curatedHits = data?.curatedHits;
  const curatedProducts = curatedHits.map(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (ele: { curated: any; document: any }) => {
      return {
        productId: ele.document.id,
        isSponsored: ele.curated,
      };
    },
  );
  const productIds = curatedProducts?.map((x: { productId: string }) => x.productId);

  assignRecommendationData?.({
    products: productIds.map((id: string) => ({ id: `makro_${id}` })) as any,
    recommendationType: '',
    totalCount: productIds?.length,
    actualCount: productIds?.length,
  });

  let productsData = await ProductService.getProductsByIdsV2(
    productIds,
    payload.storeCodes ?? [],
    payload?.isExpressMode,
    payload?.isSameDay,
    undefined,
    undefined,
    payload?.countryCode as any,
    undefined,
    mmid,
    payload?.afcStoreCodes,
    payload?.isAfcStoreEnabled,
    payload?.userSegments,
    payload?.isHorecaMemberEnabled,
  );

  productsData = productsData.map((productDetail) => {
    const matchingProduct = curatedProducts.find(
      (p: { productId: string }) => p.productId === getProductIdWithoutPrefix(productDetail?.id),
    );
    if (matchingProduct) {
      return {
        ...productDetail,
        isSponsored: matchingProduct.isSponsored,
      };
    }
    return productDetail;
  });
  const sortedProducts = productsData?.sort((a, b) => (b.isSponsored === a.isSponsored ? 0 : b.isSponsored ? 1 : -1));
  const actualResp = sortedProducts?.filter((p) => {
    return (
      isProductInStock(p as Product) &&
      getProductAvailability(
        p as Product,
        payload?.recommendationStoreCodes ?? payload?.storeCodes ?? [],
        undefined,
        undefined,
        undefined,
        undefined,
        payload?.hasAlcoholProductAvailability,
      ).isAvailable
    );
  });

  if (actualResp?.length !== 0)
    return {
      products: actualResp || [],
      recommendationType: '',
      totalCount: actualResp?.length,
    };
  else {
    return RecommendationErrorHandler.getDefaultErrorResponse();
  }
}
